import { createAppAsyncThunk } from "@/store/createAppAsyncThunk";
import { fetchPostingByIdAsync } from "./postingDetailApi";

export const fetchPostingByIdThunk = createAppAsyncThunk(
  "posting/postingDetail/fetch",
  async (id: number) => {
    const response = await fetchPostingByIdAsync(id);
    return response.data;
  },
);

// Derive PostingDetail type from API response
type PostingResponse = Awaited<ReturnType<typeof fetchPostingByIdAsync>>;
export type PostingDetail = PostingResponse["data"];
